import styled from '@emotion/styled';
import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import iconWeb from 'src/public/img/icon-web.svg';
import { color, font } from 'src/shared/styles/variables';

const BadgeWrapper = styled.div({
    position: 'absolute',
    top: -1,
    left: -1,
    right: -1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px 10px',
    backgroundColor: 'rgba(105, 109, 255, 0.1)',
    borderTopLeftRadius: '0.25rem',
    borderTopRightRadius: '0.25rem',
});

const NewBadgeWrapper = styled(BadgeWrapper)({
    backgroundColor: color.eggSour,
    top: 0,
    left: 0,
    right: 0,
});

const BadgeText = styled.p({
    color: '#696DFF',
    paddingTop: '2px',
    textTransform: 'uppercase',
    ...font.black(font.size.small),
    lineHeight: '12px',
});
const NewBadgeText = styled(BadgeText)({
    color: color.blueBayoux,
});

interface BadgeIconProps {
    iconUrl: string;
}

const BadgeIcon = styled.i<BadgeIconProps>(({ iconUrl }) => ({
    width: '10px',
    height: '10px',
    backgroundImage: `url('${iconUrl}')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    marginRight: '6px',
}));

export const WebExclusiveBadge: React.FC = () => {
    const flags = useFlags();
    const showBackendPrograms = flags?.showBackendPrograms ?? false;

    if (showBackendPrograms) {
        return (
            <NewBadgeWrapper>
                <NewBadgeText>Available till 08/01</NewBadgeText>
            </NewBadgeWrapper>
        );
    }

    return (
        <BadgeWrapper>
            <BadgeIcon iconUrl={iconWeb} />
            <BadgeText>Web-Only</BadgeText>
        </BadgeWrapper>
    );
};
